/* Early Black Friday — retitles the "Launch offer" pill. Duplicated 2.0 product only. */
(function () {
  'use strict';
  if (location.pathname.indexOf('breathefree-2-0-resistance-necklace-early-black-friday') === -1) return;

  var FROM = /launch offer/i;
  var TO = 'Black Friday: 35% off';

  var st = document.createElement('style');
  st.textContent = '.ebf-badge{background:#c8102e!important;color:#fff!important;border-color:#c8102e!important}' +
                   '.ebf-badge svg{color:#fff!important;stroke:#fff!important}';
  (document.head || document.documentElement).appendChild(st);

  function swap() {
    var nodes = document.querySelectorAll('span,div,p,li');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.children.length > 2) continue;
      if (el.getAttribute('data-ebf-badge') === '1') continue;
      var txt = (el.textContent || '').trim();
      if (!FROM.test(txt) || txt.length > 40) continue;

      /* rewrite only the text, leaving any icon in place */
      var done = false;
      for (var j = 0; j < el.childNodes.length; j++) {
        var c = el.childNodes[j];
        if (c.nodeType === 3 && FROM.test(c.nodeValue)) { c.nodeValue = ' ' + TO; done = true; }
        else if (c.nodeType === 1 && c.children.length === 0 && FROM.test(c.textContent || '')) {
          c.textContent = TO; done = true;
        }
      }
      if (!done) el.textContent = TO;
      el.setAttribute('data-ebf-badge', '1');
      var pill = el.closest('span,div');
      if (pill) pill.classList.add('ebf-badge');
      return;
    }
  }

  function start() {
    if (st.parentNode !== document.body && document.body) document.body.appendChild(st);
    swap();
    setTimeout(swap, 400);
    setTimeout(swap, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
